//during exam pariticipation, students will fillup a form, and those dropdown list are here
export const candidateCategoryDDL = [
  {
    label: "Govt.",
    value: "Govt.",
  },
  {
    label: "Non-Govt.",
    value: "Non-Govt.",
  },
  {
    label: "AMC",
    value: "AMC",
  },
  {
    label: "Others",
    value: "Others",
  },
];
//during exam pariticipation, students will fillup a form, and those dropdown list are here
export const facultySubjectDDL = [
  {
    label: "Medicine",
    value: "Medicine",
    subjects: [
      {
        label: "Internal Medicine",
        value: "Internal Medicine",
      },
      {
        label: "Cardiology",
        value: "Cardiology",
      },
      {
        label: "Pulmonology",
        value: "Pulmonology",
      },
      {
        label: "Neurology",
        value: "Neurology",
      },
      {
        label: "Gastroenterology",
        value: "Gastroenterology",
      },
      {
        label: "Nephrology",
        value: "Nephrology",
      },
      {
        label: "Hepatology",
        value: "Hepatology",
      },
      {
        label: "Haematology",
        value: "Haematology",
      },
      {
        label: "Endocrinology and Metabolism",
        value: "Endocrinology and Metabolism",
      },
      {
        label: "Rheumatology",
        value: "Rheumatology",
      },
      {
        label: "Dermatology and Venereology",
        value: "Dermatology and Venereology",
      },
      {
        label: "Psychiatry",
        value: "Psychiatry",
      },
      {
        label: "Medical Oncology",
        value: "Medical Oncology",
      },
      {
        label: "Oncology",
        value: "Oncology",
      },
      {
        label: "Radiation Oncology",
        value: "Radiation Oncology",
      },
      {
        label: "Nuclear Medicine",
        value: "Nuclear Medicine",
      },
      {
        label: "Palliative Medicine",
        value: "Palliative Medicine",
      },
      {
        label: "Physical Medicine & Rehabilitation",
        value: "Physical Medicine & Rehabilitation",
      },
      {
        label: "Transfusion Medicine",
        value: "Transfusion Medicine",
      },
      {
        label: "Child & Adolescent Psychiatry",
        value: "Child & Adolescent Psychiatry",
      },
      {
        label: "No Subject",
        value: 0,
      },
    ],
  },
  {
    label: "Surgery",
    value: "Surgery",
    subjects: [
      {
        label: "General Surgery",
        value: "General Surgery",
      },
      {
        label: "Orthopaedic Surgery",
        value: "Orthopaedic Surgery",
      },
      {
        label: "Otolaryngology",
        value: "Otolaryngology",
      },
      {
        label: "Neurosurgery",
        value: "Neurosurgery",
      },
      {
        label: "Hepatobiliary Surgery",
        value: "Hepatobiliary Surgery",
      },
      {
        label: "Colorectal Surgery",
        value: "Colorectal Surgery",
      },
      {
        label: "Paediatric Surgery",
        value: "Paediatric Surgery",
      },
      {
        label: "Urology",
        value: "Urology",
      },
      {
        label: "Anaesthesiology",
        value: "Anaesthesiology",
      },
      {
        label: "Critical Care Medicine",
        value: "Critical Care Medicine",
      },
      {
        label: "Radiology and Imaging",
        value: "Radiology and Imaging",
      },
      {
        label: "Ophthalmology",
        value: "Ophthalmology",
      },
      {
        label: "Community Ophthalmology",
        value: "Community Ophthalmology",
      },
      {
        label: "Plastic Surgery",
        value: "Plastic Surgery",
      },
      {
        label: "Surgical Oncology",
        value: "Surgical Oncology",
      },
      {
        label: "Cardiovascular & Thoracic Surgery",
        value: "Cardiovascular & Thoracic Surgery",
      },
      {
        label: "Thoracic Surgery",
        value: "Thoracic Surgery",
      },
      {
        label: "Vascular Surgery",
        value: "Vascular Surgery",
      },
      {
        label: "No Subject",
        value: 0,
      },
    ],
  },
  {
    label: "Obstetrics and Gynaecology",
    value: "Obstetrics and Gynaecology",
    subjects: [
      {
        label: "Obstetrics and Gynaecology",
        value: "Obstetrics and Gynaecology",
      },
      {
        label: "Feto-Maternal Medicine",
        value: "Feto-Maternal Medicine",
      },
      {
        label: "Gynaecological Oncology",
        value: "Gynaecological Oncology",
      },
      {
        label: "Reproductive Endocrinology and Infertility",
        value: "Reproductive Endocrinology and Infertility",
      },
      {
        label: "No Subject",
        value: 0,
      },
    ],
  },
  {
    label: "Paediatrics",
    value: "Paediatrics",
    subjects: [
      {
        label: "Paediatrics",
        value: "Paediatrics",
      },
      {
        label: "Neonatology",
        value: "Neonatology",
      },
      {
        label: "Paediatric Cardiology",
        value: "Paediatric Cardiology",
      },
      {
        label: "Paediatric Gastroenterology",
        value: "Paediatric Gastroenterology",
      },
      {
        label: "Paediatric Hematology and Oncology",
        value: "Paediatric Hematology and Oncology",
      },
      {
        label: "Paediatric Nephrology",
        value: "Paediatric Nephrology",
      },
      {
        label: "Paediatric Neurology & Neuro Development",
        value: "Paediatric Neurology & Neuro Development",
      },
      {
        label: "Paediatric Rheumatology",
        value: "Paediatric Rheumatology",
      },
      {
        label: "No Subject",
        value: 0,
      },
    ],
  },
  {
    label: "Basic Science",
    value: "Basic Science",
    subjects: [
      {
        label: "Anatomy",
        value: "Anatomy",
      },
      {
        label: "Physiology",
        value: "Physiology",
      },
      {
        label: "Biochemistry",
        value: "Biochemistry",
      },
      {
        label: "Pathology",
        value: "Pathology",
      },
      {
        label: "Microbiology",
        value: "Microbiology",
      },
      {
        label: "Pharmacology",
        value: "Pharmacology",
      },
      {
        label: "Forensic Medicine",
        value: "Forensic Medicine",
      },
      {
        label: "Laboratory Medicine",
        value: "Laboratory Medicine",
      },
      {
        label: "Virology",
        value: "Virology",
      },
      {
        label: "No Subject",
        value: 0,
      },
    ],
  },
  {
    label: "Dental Science MD faculty",
    value: "Dental Science MD faculty",
    subjects: [
      {
        label: "Dental Materials",
        value: "Dental Materials",
      },
      {
        label: "Dental Pharmacology",
        value: "Dental Pharmacology",
      },
      {
        label: "Oral Anatomy",
        value: "Oral Anatomy",
      },
      {
        label: "Oral & Maxillofacial Pathology",
        value: "Oral & Maxillofacial Pathology",
      },
      {
        label: "Periodontology",
        value: "Periodontology",
      },
      {
        label: "No Subject",
        value: 0,
      },
    ],
  },
  {
    label: "Dental Science MS faculty",
    value: "Dental Science MS faculty",
    subjects: [
      {
        label: "Conservative Dentistry & Endodontics",
        value: "Conservative Dentistry & Endodontics",
      },
      {
        label: "Oral & Maxi. Surgery",
        value: "Oral & Maxi. Surgery",
      },
      {
        label: "Orthodontics",
        value: "Orthodontics",
      },
      {
        label: "Paediatric Dentistry",
        value: "Paediatric Dentistry",
      },
      {
        label: "Prosthodontics",
        value: "Prosthodontics",
      },
      {
        label: "No Subject",
        value: 0,
      },
    ],
  },
  {
    label: "BCS",
    value: "BCS",
    subjects: [
      {
        label: "BCS",
        value: "BCS",
      },
    ],
  },
  {
    label: "No faculty",
    value: 0,
    subjects: [
      {
        label: "No Subject",
        value: 0,
      },
    ],
  },
];
